export default {"src":"/_next/static/media/loader.5d08a88d.gif","height":53,"width":200,"blurWidth":0,"blurHeight":0};